import React, { useContext, useEffect, useState } from "react";
import AuthManager from "../../../Common/AuthManager";
import Utils from "../../../Common/Utils";
import { AppContext } from "../../../Context/AppContext";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import Label from "../../Common/components/Label";
import Paginator from "../../Common/Paginator";
import TableSkeletonElement from "../Products/components/TableSkeletonElement";

const PDWTracker = () => {
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let appData = useContext(AppContext);
  let industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;

  let [apiCalled, setApiCalled] = useState(false);

  let [recordPerPage, setRecordPerPage] = useState(100);
  let [filteredList, setFilteredList] = useState([]);
  const pageRange = 10;
  let [singlePageProducts, setSinglePageProducts] = React.useState([]);

  useEffect(() => {
    load_status_data();
  }, [industryId]);

  async function load_status_data() {
    setFilteredList((prev) => []);
    setApiCalled((prev) => !prev);

    let res = await ServiceWrapper.doGet(
      `${api_base_url}pdw/industry/list`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    let descedingOrder = res?.data?.data?.sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );

    if (!res.errorfound) {
      if (res.data.done) {
        setFilteredList(descedingOrder);
        setApiCalled((prev) => !prev);
      } else {
        setApiCalled((prev) => !prev);
      }
    } else {
      setApiCalled((prev) => !prev);
    }
  }

  async function handle_page_change(pagenumber, paged_data) {
    if (paged_data !== undefined) {
      setSinglePageProducts(paged_data);
    }
    await Utils.sleep(100);
  }

  return (
    <div className="mb-4 ps-1 pt-0 w-100 pe-3">
      <div className="d-flex mb-2 justify-content-end align-items-end">
        <button
          type="button"
          className="btn btn-light btn-sm"
          style={{
            color: "#091caa",
            background: "none",
            border: "none",
            boxShadow: "none",
          }}
          onClick={() => load_status_data()}
        >
          <i className="fa fa-sync-alt" />
        </button>
      </div>
      {filteredList && filteredList.length > 0 ? (
        <div className="col-12">
          <div
            className="table-responsive "
            style={{
              maxHeight: "75vh",
              maxWidth: "100vw",
              borderRight: "2px solid #e6e6e6",
              borderLeft: "2px solid #e6e6e6",
              borderBottom: "2px solid #e6e6e6",
            }}
          >
            <table className="table table-sm">
              <thead>
                <tr
                  style={{
                    background: "#DCDCDC",
                    border: "1px solid #c9cccf",
                    height: "43",
                    fontFamily: "Noto Sans",
                    fontWeight: 400,
                    margin: "42px 0 12px",
                    color: "#5c5f62",
                  }}
                >
                  <th
                    className="border-1 border-bottom-0"
                    scope="col"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      fontWeight: 400,
                      padding: "13px 31px 11px 20px",
                    }}
                  >
                    NAME/ID
                  </th>
                  <th
                    className="border-1 border-bottom-0"
                    scope="col"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      fontWeight: 400,
                      padding: "13px 31px 11px 20px",
                    }}
                  >
                    Status
                  </th>
                  <th
                    className="border-1 border-bottom-0"
                    scope="col"
                    width="30%"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      fontWeight: 400,
                      padding: "13px 31px 11px 20px",
                    }}
                  >
                    Created On
                  </th>
                  <th
                    className="border-0"
                    scope="col"
                    width="30%"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      fontWeight: 400,
                      padding: "13px 31px 11px 20px",
                    }}
                  >
                    Updated at
                  </th>
                </tr>
              </thead>
              {singlePageProducts.map((data, index) => {
                return (
                  <tbody
                    key={data?.id}
                    style={{
                      backgroundColor: `${
                        index % 2 === 0 ? "white" : "#F2F2F2"
                      }`,
                    }}
                  >
                    <tr className="border-1" key={index}>
                      <th
                        className="border-1 border-bottom-0 align-middle "
                        style={{
                          height: "43",
                          fontFamily: "Noto Sans",
                          cursor: "pointer",
                          fontWeight: 400,
                          padding: "13px 31px 11px 20px",
                        }}
                      >
                        <Label
                          message={data.filename}
                          fontSize={0.875}
                          fontWeight="400"
                          fontFamily="Noto Sans"
                        />
                        <br />
                        <Label
                          message={data.id}
                          fontSize={0.7}
                          fontWeight="300"
                          fontFamily="Noto Sans"
                        />
                      </th>
                      <th
                        className="border-1 border-bottom-0 align-middle "
                        style={{
                          height: "43",
                          fontFamily: "Noto Sans",
                          cursor: "pointer",
                          fontWeight: 400,
                          padding: "13px 31px 11px 20px",
                        }}
                      >
                        <div>
                          {Utils.getListFromCommaSeparatedString(
                            data.status
                          ).map((item, index) => {
                            return (
                              <div className="d-inline" key={index}>
                                <span
                                  className="badge"
                                  style={{
                                    fontSize: "0.75rem",
                                    backgroundColor: "#F2F2F2",
                                    marginBottom: "10px",
                                    color: "#5c5f62",
                                    fontFamily: "Noto Sans",
                                    fontWeight: "401",
                                    padding: "6px",
                                  }}
                                >
                                  {item}
                                </span>
                                &nbsp;&nbsp;
                              </div>
                            );
                          })}
                        </div>
                      </th>
                      <th
                        className="border-1 border-bottom-0 align-middle "
                        style={{
                          height: "43",
                          fontFamily: "Noto Sans",
                          cursor: "pointer",
                          fontWeight: 400,
                        }}
                      >
                        <Label
                          message={data.created_on + " UTC"}
                          fontSize={0.75}
                          fontWeight="400"
                          fontFamily="Noto Sans"
                        />
                      </th>
                      <th
                        className="border-1 border-bottom-0 align-middle "
                        style={{
                          height: "43",
                          fontFamily: "Noto Sans",
                          cursor: "pointer",
                          fontWeight: 400,
                        }}
                      >
                        <Label
                          message={data.updated_at + " UTC"}
                          fontSize={0.75}
                          fontWeight="400"
                          fontFamily="Noto Sans"
                        />
                      </th>
                    </tr>
                  </tbody>
                );
              })}
            </table>
          </div>
          <div className="mt-3">
            {filteredList && filteredList.length > 0 && (
              <div className="d-flex justify-content-end">
                &nbsp;
                <select
                  className="form-select form-select-sm"
                  style={{ width: "70px" }}
                  aria-label="Default select example"
                  defaultValue={100}
                  onChange={(e) => setRecordPerPage(e.target.value)}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={200}>200</option>
                  <option value={500}>500</option>
                  <option value={10000}>All</option>
                </select>
                &nbsp;
                <Paginator
                  recordPerPage={recordPerPage}
                  totalRecords={filteredList.length}
                  data={filteredList}
                  pageRange={pageRange}
                  onPageChange={handle_page_change}
                  simple={true}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>
          {apiCalled && <TableSkeletonElement />}
          <div className={`${apiCalled ? "invisible" : "visible"}`}>
            <div className="default-page mt-5 text-center">
              <img
                src={process.env.PUBLIC_URL + "/img/place_holder_no_data.svg"}
                alt="logo"
                style={{
                  width: "auto",
                  height: "100px",
                  color: "#091caa",
                }}
              />
              <br />
              <Label
                message="No data found"
                fontSize={1.5}
                fontWeight="600"
                color="#091caa"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PDWTracker;
